import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { Text } from "react-internationalization";
import { setStateParams } from "../../Redux/Actions/webAppActions";
import { FieldLabel } from "../translations/dynamic";
import { DataValidation, ILS_CONSTS, VERDA_CONSTS } from "../../Utils/StaticData/Constant";
import { LANG } from "../translations/dynamic";
class Step2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formerEmpOfSharp: false,
      retireEmpOfSharp: false,
      checkedState: new Array(this.props.qsns.length).fill(false),
      qsns: [],
      qsnscount: 0,
      dataKey: 0,
    };
  }

  handleOnChange = async (e, position, qnId, qnSelected) => {
    const _qsns = [...this.state.qsns];
    const qsns = _qsns.map((item, index) => {
      if (position === index) {
        // if (selectedCount.length === 5) {
        if (item.selected === true) {
          return {
            ...item,
            disabled: !e.target.checked,
            selected: e.target.checked,
          };
        } else {
          return {
            ...item,
            selected: e.target.checked,
          };
        }
        // } else {
        //   return {
        //     ...item,
        //    // disabled: false,
        //     selected: e.target.checked,
        //     disabled:!e.target.checked,
        //   };
        // }
      } else {
        return {
          ...item,
        };
      }
      // index===position ?!item:item
    });
    const selectedCount = qsns.filter((qs) => qs.selected === true);

    this.setState({
      checkedCount: selectedCount.length,
    });
    let qsnsForPayload = qsns
      .filter((qs) => qs.selected && qs.subQuestion === false)
      .map((qs) => ({
        qsnMetaId: qs.questionId,
        answer: "yes",
      }));

    const getsubQuestionId = qsnsForPayload?.map((qs) => {
      return this.props.qsns.filter((el) => el.questionId === qs.qsnMetaId);
    });
    let subQuestionId = [];
    for (let i = 0; i < getsubQuestionId.length; i++) {
      subQuestionId.push(getsubQuestionId[i][0].answersvo[0]?.subQuestions);
    }

    let DatePayload = this.props?.questionDate.filter((qsn) => {
      if (subQuestionId.includes(qsn.qsnMetaId)) {
        return qsn;
      }
    });
    if (DatePayload.length > 0) {
      qsnsForPayload = qsnsForPayload.concat(DatePayload);
    }

    let SelectedDates = qsns
      .filter((qs) => qs.selected)
      .filter((ans) => ans.answersvo.length !== 0);
    SelectedDates = SelectedDates.map((anss) => anss.answersvo[0]);
    await this.props.setStateParams("SelectedDates", SelectedDates);

    const dateInd = qsns
      .filter((qs) => qs.selected)
      .map((qs) => ({
        dateInd: qs.dateInd,
        id: qs.questionId,
      }));
    this.props.setQSNS(qsnsForPayload, dateInd, qnId);
    //this.props.setDateInd(dateInd);
    this.setState({
      qsns,
    });
  };

  // }
  componentDidMount() {
    //const selectedPlan = this.props.selectedPlan;

    let attestationList = [];
    let NewquestionDates = [];
    if (this.props?.qsns?.length > 0) {
      let qsns = this.props.qsns;

      if (this.props.attestationList?.length > 0) {
        qsns = qsns.map((qs) => {
          if (
            this.props.attestationList
              .filter((data) => data.answer === "yes")
              .some((data) => data.qsnMetaId === qs.questionId)
          ) {
            return {
              ...qs,
              disabled: false,
              selected: true,
            };
          } else {
            return {
              ...qs,
              disabled: false,
              selected: false,
            };
          }
        });
      } else {
        qsns = this.props.qsns.map((qs) => ({
          ...qs,
          selected: false,
          //disabled:false
        }));
      }

      this.setState({ qsns });
      this.setState({
        checkedCount: qsns.filter((qsn) => qsn.selected === true).length,
      });
    } else {
      if (
        this.props.preEnrollInfo.attestationList &&
        this.props.preEnrollInfo.attestationList.length > 0
      ) {
        // this.setState({attestationList:this.props.preEnrollInfo.attestationList})

        const qsns = this.props.qsns.map((qs, index) => {
          if (
            this.props.preEnrollInfo.attestationList
              .filter((data) => data.answer === "yes")
              .some((data) => data.qsnMetaId === qs.questionId)
          ) {
            return {
              ...qs,
              disabled: false,

              selected: true,
            };
          } else {
            return {
              ...qs,
              disabled: false,

              selected: false,
            };
          }
        });

        this.setState({ qsns });
        this.setState({
          checkedCount: qsns.filter((qsn) => qsn.selected === true).length,
        });
      }
    }
  }

  render() {
    const { data } = this.props;
    return (
      <React.Fragment>
        <div
          class={
            data?.appStatus === "READY" || data?.appStatus === "SUBMITTED"
              ? "tab-content tab-contentSharp disable-form"
              : "tab-content tab-contentSharp"
          }
        >
          <div id="step3" class="container-Cambia tab-pane active">
            <React.Fragment>
              <h3 class="tab-heading">
                <Text id="step3.Exhibit1a" /> – <Text id="step3.stepsub" />
              </h3>
            </React.Fragment>
            <p>
              {this.state.retireEmpOfSharp === true ? (
                <strong>
                  Typically, you may enroll in a Medicare Advantage plan only
                  during the City of San Diego Medicare Retirees' open
                  enrollment period which is in June each year.
                </strong>
              ) : (
                <strong>
                  <Text id="step3.Para1" />.
                </strong>
              )}
              <Text id="step3.Para2" />.
            </p>
            <p>
              <Text id="step3.Para3" />.
              <Text id="step3.subPara3" />.
            </p>
            <ul
              class="list-group attestation-container-mobile-aligner"
              id="step3_checklist"
            >
              <li class="list-group-item">
                <div class="custom-control custom-checkbox custom-control-inline">
                  <div class="display-block">
                    {this.state.qsns.map(
                      (qsns, index) =>
                        !qsns.subQuestion && (
                          <>
                            <div
                              class={
                                qsns.questionText.length > 127
                                  ? "attestation"
                                  : "attestation1"
                              }
                            >
                              <input
                                type="checkbox"
                                class="custom-control-input"
                                id={qsns.questionId}
                                name={qsns.questionId}
                                value={qsns.questionId}
                                checked={
                                  qsns.selected
                                  // this.props.pendingApplFlag &&
                                  // this.props.data.attestationList != undefined
                                  //   ? this.props.data.attestationList.length > 0
                                  //     ? this.props.data.attestationList.filter(
                                  //         (qsn) => qsn.qsnMetaId === qsns.questionId
                                  //       )[0]
                                  //       ? true
                                  //       : false
                                  //     : qsns.selected
                                  //   : qsns.selected
                                }
                                onChange={(e) =>
                                  this.handleOnChange(
                                    e,
                                    index,
                                    qsns.questionId,
                                    qsns.selected
                                  )
                                }
                                disabled={
                                  this.state.checkedCount === 5 &&
                                  !qsns.selected
                                }
                              />
                              {this.props.qsns.length > 1 && index > 0 ? (
                                <hr class="qsnsunderline" />
                              ) : (
                                ""
                              )}
                              <label
                                class="custom-control-label"
                                for={qsns.questionId}
                              >
                                <strong>
                                {this.props.lang === "es" &&
                                LANG.ATTESTATIONS[qsns.questionText]
                                  ? LANG.ATTESTATIONS[qsns.questionText]
                                  : qsns.questionText}
                                </strong>
                              </label>
                              {qsns?.questionText==="Other" &&
                               this.props.customerId===ILS_CONSTS.ID &&
                                  <input
                                    type="text"
                                    class="form-control"
                                    id={"otherId"}
                                    name={"attestationOther"}
                                    value={qsns.selected?this.props.data?.attestationOther:""}
                                    onChange={(event)=>{if (
                                      event.target.value !== "" &&
                                      !DataValidation.test(event.target.value)
                                    ) {
                                      return;
                                    }
                                    this.props.handleChange(event);
                                  }
                                  }
                                    disabled={!qsns.selected}
                                    style={{border:"1px solid #999"}}
                                  />
                              }
                            </div>

                            {/* <br /> */}

                            {qsns.dateInd === "y" && qsns.selected === true ? (
                              <React.Fragment>
                                <label for="questionDate" class="attestmargin">
                                  {/* <Text id="step3.movedate" />* */}
                                  {/* Insert Date* */}

                                  {/* {qsns.answersvo.length &&
                                    this.state.qsns[
                                      qsns.answersvo[0].subQuestions
                                    ].questionText} */}
                              {qsns.answersvo.length &&
                                this.props.lang === "es" &&
                                LANG.ATTESTATIONS.SUBQUESTION[
                                  this.state.qsns.filter(
                                    (el) =>
                                      el.questionId ===
                                      qsns.answersvo[0]?.subQuestions
                                  )?.[0]?.questionText
                                ]
                                  ? LANG.ATTESTATIONS.SUBQUESTION[
                                      this.state.qsns.filter(
                                        (el) =>
                                          el.questionId ===
                                          qsns.answersvo[0]?.subQuestions
                                      )?.[0]?.questionText
                                    ]
                                  : this.state.qsns.filter(
                                      (el) =>
                                        el.questionId ===
                                        qsns.answersvo[0]?.subQuestions
                                    )?.[0]?.questionText
                              }
                                  <input
                                    type="input"
                                    id={
                                      this.props.qsns[index]?.answersvo[0]
                                        ?.subQuestions
                                    }
                                    name="questionDate"
                                    value={
                                      this.props.attestationList?.length > 0
                                        ? this.props.attestationList.filter(
                                            (data2) =>
                                              data2.qsnMetaId ===
                                              this.props.qsns[index]
                                                ?.answersvo[0]?.subQuestions
                                          )[0]?.answer
                                        : data.questionDate?.answer
                                    }
                                    // class=""
                                    placeholder="MM/DD/YYYY"
                                    maxLength="10"
                                    onChange={(e) => {
                                      //this.props.handleDates("questionDate")

                                      this.props.handleAttestationDate(
                                        e,
                                        this.props.qsns[index]?.answersvo[0]
                                          ?.subQuestions
                                      );
                                    }}
                                    onClick={(e) => {
                                      //this.props.handleDates("questionDate")

                                      this.props.qsnsDate(
                                        this.props.qsns[index]?.answersvo[0]
                                          ?.subQuestions
                                      );
                                    }}
                                    className={
                                      this.props.questionDate.filter(
                                        (qs) =>
                                          qs.qsnMetaId ===
                                          this.props.qsns[index]?.answersvo[0]
                                            ?.subQuestions
                                      )?.length === 1 &&
                                      moment(
                                        this.props.questionDate.filter(
                                          (data2) =>
                                            data2.qsnMetaId ===
                                            this.props.qsns[index]?.answersvo[0]
                                              ?.subQuestions
                                        )[0]?.answer,
                                        "MM/DD/YYYY",
                                        true
                                      ).isValid()
                                        ? "form-control display-inline scrollfix"
                                        : "error-input scrollfix"
                                    }
                                    autoComplete="off"
                                    spellcheck="false"
                                    aria-autocomplete="both"
                                    aria-haspopup="false"
                                  />
                                </label>
                              </React.Fragment>
                            ) : null}
                          </>
                        )
                    )}
                    {this.state.qsns.some((s)=>s?.selected===true && s.questionId==="42") && this.props.customerId===VERDA_CONSTS.ID &&
                      <>
                      <div className="attestation">
                        <p><span>Please specify the following:</span></p>
                        <span>Weather-related emergency or major disaster:</span>{"  "}
                        <input
                          type="text"
                          value={this.props.data?.attestationMajorDisaster}
                          className="form-control verda-attestation"
                          name="attestationMajorDisaster"
                          id="attestationMajorDisaster"
                          onChange={(e)=>this.props.handleChange(e)}
                        />
                        <span>Election period missed:</span>{"  "}
                        <input
                          type="text"
                          value={this.props.data?.attestationElectionMissed}
                          className="form-control verda-attestation"
                          name="attestationElectionMissed"
                          id="attestationElectionMissed"
                          onChange={(e)=>this.props.handleChange(e)}
                        />
                      </div>
                      </>
                    }
                  </div>
                </div>
              </li>
            </ul>
            <p class="mt-3">{FieldLabel("step2Para", this.props.customerId)}</p>
            {this.props.preEnrollInfo?.appStatus != "READY" &&
              this.props.preEnrollInfo?.appStatus != "SUBMITTED" && (
                <button
                  class="btn btn-saveNext save-next-color"
                  id="next2"
                  onClick={this.props.redirect}
                  disabled={
                    this.props?.Submitted ||
                    this.props.preEnrollInfo?.appStatus === "READY" ||
                    this.props.preEnrollInfo?.appStatus === "SUBMITTED"
                  }
                >
                  <Text id="app.Save_Next" />
                </button>
              )}
            {/* ) : null} */}
          </div>
        </div>
      </React.Fragment>
    );
  }
}
const mapDispatchToProps = {
  setStateParams,
};
const mapStateToProps = (state) => {
  return {
    year: state.webApp.year,
    qsns: state.webApp.qsns,
    preEnrollInfo: state.webApp.preEnrollInfo,
    pendingApplFlag: state.webApp.pendingApplFlag,
    SelectedDates: state.webApp.SelectedDates,
    currentDateid: state.webApp.currentDateid,
    Submitted: state.webApp.Submitted,
    customerId: state.login.customerId,
    lang: state.webApp.language,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Step2);
